import React from "react";
import ReactDOM from "react-dom/client";
import {BrowserRouter as Router} from "react-router-dom";
import {createStore, applyMiddleware} from "redux";
import {composeWithDevTools} from "redux-devtools-extension";
import createSagaMiddleware from "redux-saga";
import {Provider} from "react-redux";
import {reducers} from "./reducers";
import {sagas} from "./sagas";
import App from "./containers/App";
import reportWebVitals from './reportWebVitals';
import AppContext from "./context/AppContext";
import { I18nextProvider } from "react-i18next";
import i18next from "i18next";
import ar from "./translations/ar-SA.json";
import en from "./translations/en-GB";
import { ClearCacheProvider } from 'react-clear-cache';

i18next.init({
  interpolation: { escapeValue: false },
  lng: localStorage.getItem('i18nextLng') || 'en',
  resources: {
    en: {
      translation: en
    },
    ar: {
      translation: ar
    },
  },
});

const saga = createSagaMiddleware();
const publicURL = process.env.REACT_APP_PUBLIC_URL;

export const store = createStore(reducers, composeWithDevTools(
  applyMiddleware(saga)
));

saga.run(sagas);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <Router basename={publicURL}>
      <I18nextProvider i18n={i18next}>
        <AppContext>
          <ClearCacheProvider duration={5000} basePath='/mashhad'>
            <App />
          </ClearCacheProvider>
        </AppContext>
      </I18nextProvider>
    </Router>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
